// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8 4.05C7.24 2.98 6.32 2.2 5.1 2.2C3.01 2.2 1.5 3.81 1.5 5.85C1.5 8.33 3.45 10.18 6.96 13.17C7.56 13.69 8.44 13.69 9.04 13.17C12.55 10.18 14.5 8.33 14.5 5.85C14.5 3.81 12.99 2.2 10.9 2.2C9.68 2.2 8.76 2.98 8 4.05Z',
  'M2.2 8.3H5.5L6.5 6.9L8 10.6L9.5 5.95L10.5 8.3H13.8',
];
